import { call } from 'redux-saga/effects';
import { unsubscribeFromScreenshareSaga } from 'features/screenshare/sagas/unsubscribeFromScreenshareSaga';
import { SelectedScreenshare } from 'features/screenshare/types';
import { FeedId } from 'features/streaming/types';
import { RTCClient } from 'utils/webrtc';

/**
 * Stops receiving a screenshare the user is no longer looking at, keeping the
 * subscription alive so it can be resumed cheaply.
 */
export function* pauseScreenshareSaga(feedId: FeedId) {
  const screenshare: SelectedScreenshare = {
    feedId,
    userId: RTCClient.userIdByScreensharingFeedId[feedId],
  };

  yield call(unsubscribeFromScreenshareSaga, screenshare);
}
